import React, { useState } from 'react'
import './webflow.css'
import './balanz.webflow.css'
import './normalize.css'
import { Routes, Route } from "react-router-dom";
import { LoginUsuario } from './modules/LoginUsuario'
import { NewUser } from './modules/NewUser'
import { VerifyUser } from './modules/VerifyUser'
import { ForgotPassword } from './modules/ForgotPassword'
import { RestorePassword } from './modules/RestorePassword'
import { ClientDashBoard } from './modules/ClientDashBoard'
import { UserRequest } from './modules/UserRequest'
import { CheckYourEmail } from './modules/CheckYourEmail'
import { ChangePassword } from './modules/ChangePassword'
import { Reporte } from './modules/Reporte'
import { MyGlobalContext } from './context/helpersProvider'
import { ToastBase } from './components/Toast/ToastBase'
import { Loader } from './components/Loader'
import { Component404 } from './modules/404'
import { VerifyInfo } from './modules/VerifyInfo'
import { SuccessAccount } from './modules/SuccessAccount'

function App() {
  interface toast {
    open: string
    type: string
    message: string
  }

  const [showLoading, setShowLoading] = useState<string>('false')

  const [showToast, setShowToast] = useState<toast>({
    open: 'false',
    type: '',
    message: '',
  })

  return (
    <React.Fragment>
      <MyGlobalContext.Provider value={{ showLoading, showToast, setShowLoading, setShowToast }}>

        <Routes>
          <Route path='/' element={<LoginUsuario/>} />
          <Route path='/home' element={<ClientDashBoard/>} />
          <Route path='/forgot' element={<ForgotPassword/>} />
          <Route path='/restore/:code' element={<RestorePassword/>} />
          <Route path='/create' element={<NewUser/>} />
          <Route path='/request' element={<UserRequest/>} />
          <Route path='/verify' element={<VerifyUser/>} />
          <Route path='/verify_info' element={<VerifyInfo/>} />
          <Route path='/successful_account' element={<SuccessAccount/>} />

          <Route path='/check' element={<CheckYourEmail/>} />

          <Route path='/user' element={<ChangePassword/>} />
          <Route path='/reporte/:id' element={<Reporte/>} />
          <Route path={'/404'} element={<Component404/>} />
          <Route path='*' element={<Component404/>} />
        </Routes>
        <ToastBase />
        <Loader />
      </MyGlobalContext.Provider>
    </React.Fragment>
  )
}

export default App
